import React, { useState } from "react";
import "../css/contactus.scss";
import siteConfig from "../siteConfig";

function Contact() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    subject: "",
    message: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [errors, setErrors] = useState({});

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    // 清除该字段的错误信息
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  // 验证邮箱格式
  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  // 验证所有字段并返回错误信息
  const validateForm = () => {
    const newErrors = {};

    if (!formData.firstName.trim()) {
      newErrors.firstName = "First name is required";
    }
    if (!formData.lastName.trim()) {
      newErrors.lastName = "Last name is required";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!isValidEmail(formData.email)) {
      newErrors.email = "Please enter a valid email address";
    }

    if (!formData.subject) {
      newErrors.subject = "Please select a subject";
    }

    if (!formData.message.trim()) {
      newErrors.message = "Message is required";
    } else if (formData.message.trim().length < 10) {
      newErrors.message = "Message must be at least 10 characters";
    }

    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // 验证表单
    const formErrors = validateForm();

    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      // 滚动到第一个错误字段
      const firstErrorField = Object.keys(formErrors)[0];
      const element = document.getElementById(firstErrorField);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "center" });
        element.focus();
      }
      return;
    }

    setIsSubmitting(true);
    setErrors({});

    // 模拟表单提交
    setTimeout(() => {
      setShowSuccess(true);
      setFormData({
        firstName: "",
        lastName: "",
        email: "",
        subject: "",
        message: "",
      });
      setIsSubmitting(false);

      // 滚动到顶部显示成功消息
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });

      // 5秒后隐藏成功消息
      setTimeout(() => {
        setShowSuccess(false);
      }, 5000);
    }, 1000);
  };
  return (
    <main className="contact">
      <section className="contact-heading"><p>WE'D LOVE TO HEAR FROM YOU</p><h1>Say hello!</h1></section>
      <div className="contact-layout page-shell">
        <section className="contact-details"><h2>Business details</h2><p>{siteConfig.contact.company}</p><p>{siteConfig.contact.address}</p><p>{siteConfig.contact.hours}</p><hr /><h2>Get in touch</h2><a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a><p>For order questions, please include your order number.</p></section>
        <form className="contact-form" onSubmit={handleSubmit} noValidate>
          {showSuccess && <div className="contact-success" role="status">Thanks! Your message is on its way.</div>}
          <div className="contact-form-row"><label>First name<input id="firstName" name="firstName" value={formData.firstName} onChange={handleInputChange} />{errors.firstName && <small>{errors.firstName}</small>}</label><label>Last name<input id="lastName" name="lastName" value={formData.lastName} onChange={handleInputChange} />{errors.lastName && <small>{errors.lastName}</small>}</label></div>
          <label>Email<input id="email" name="email" type="email" value={formData.email} onChange={handleInputChange} />{errors.email && <small>{errors.email}</small>}</label>
          <label>What can we help with?<select id="subject" name="subject" value={formData.subject} onChange={handleInputChange}><option value="">Select a subject</option><option>Order question</option><option>Product question</option><option>Return or damaged item</option><option>Accessibility support</option><option>Privacy request</option></select>{errors.subject && <small>{errors.subject}</small>}</label>
          <label>Message<textarea id="message" name="message" rows="6" value={formData.message} onChange={handleInputChange} />{errors.message && <small>{errors.message}</small>}</label>
          <button disabled={isSubmitting}>{isSubmitting ? "Sending…" : "Send message"}</button>
        </form>
      </div>
    </main>
  );
}

export default Contact;
